import type {
  CreateFeedbackRequest,
  FeedbackListResponse,
  FeedbackMeldung,
} from '@brandschutz/shared';
import { api } from '@/lib/api';

export async function meldeFeedback(payload: CreateFeedbackRequest): Promise<FeedbackMeldung> {
  const { data } = await api.post<FeedbackMeldung>('/feedback', payload);
  return data;
}

export async function listFeedback(
  params: {
    status?: 'offen' | 'uebermittelt' | 'fehlgeschlagen' | 'alle';
  } = {},
): Promise<FeedbackListResponse> {
  const { data } = await api.get<FeedbackListResponse>('/feedback', { params });
  return data;
}

export async function uebermittleFeedback(id: number): Promise<FeedbackMeldung> {
  const { data } = await api.post<FeedbackMeldung>(`/feedback/${id}/uebermitteln`);
  return data;
}
